
export class RadResultBaseModel {
    
    id: number;
    natije: string;

    constructor(
        id: number,
        natije: string
    ) {
        this.id = id;
        this.natije = natije;
    }

    public static fromJson(json: any): RadResultBaseModel {
        return new RadResultBaseModel(
            json["id"],
            json["natije"]
        );
    }
}